var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"renderCanvas",staticClass:"switching-room",attrs:{"id":"renderCanvas"}})}
var staticRenderFns = []

export { render, staticRenderFns }